import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ReactSVG from 'react-svg';

const Footer = ({ classname }) => {
  const pageCssBEM = 'footer';
  const classes = classnames(pageCssBEM, classname);
  const date = new Date();

  return <footer className={ classes }>
    <div className={`${pageCssBEM}__container`}>
      <div className={`${pageCssBEM}__disclosure`}>
        <FormattedMessage id="footer.disclosureTitle" tagName="b" />
        <FormattedMessage id="footer.disclosure" />
      </div>
      <div className={`${pageCssBEM}__products`}>
        <FormattedMessage id="footer.products" tagName="div" />
        <ul>
          <li><FormattedMessage id="footer.products.fdic" /></li>
          <li><FormattedMessage id="footer.products.bank" /></li>
          <li><FormattedMessage id="footer.products.value" /></li>
          <li><FormattedMessage id="footer.products.deposits" /></li>
          <li><FormattedMessage id="footer.products.insured" /></li>
          <li><FormattedMessage id="footer.products.condition" /></li>
        </ul>
      </div>
      <div className={`${pageCssBEM}__copyright`}>
        &copy; { date.getFullYear() } <FormattedMessage id="footer.copyright" />
      </div>
      <div className={`${pageCssBEM}__trademarks`}>
        <FormattedMessage id="footer.trademarkShort" />
      </div>
      <div className={`${pageCssBEM}__logos`}>
          <ReactSVG src="/classpath/assets/images/equalHousingWithText.svg"/>
          <ReactSVG src="/classpath/assets/images/fdic.svg"/>
        </div>
    </div>
  </footer>;
};

export default Footer;
